export default __webpack_public_path__ + "static/media/8d.ea20b009.png";